import React from 'react';
import Floater from 'react-floater';
import PropTypes from 'prop-types';
import { baseStyles, oneIconStyles } from './TourGuidePointer.styles';

export const TourGuidePointer = ({
  target,
  number,
  placement,
  offset,
  zIndex,
  hideNumber,
  floaterStyles,
}) => {
  const icon = <div>{number}</div>;
  return !target ? (
    <div style={oneIconStyles}>{number}</div>
  ) : (
    <Floater
      open
      target={target}
      content={icon}
      placement={placement}
      offset={offset}
      styles={baseStyles({ placement, zIndex, floaterStyles })}
    >
      {!hideNumber && <div style={oneIconStyles}>{number}</div>}
    </Floater>
  );
};

TourGuidePointer.propTypes = {
  target: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  number: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  placement: PropTypes.oneOf([
    'left',
    'bottom',
    'right',
    'top',
    'top-end',
    'bottom-start',
  ]),
  offset: PropTypes.number,
  zIndex: PropTypes.number,
  hideNumber: PropTypes.bool,
  floaterStyles: PropTypes.shape({}),
};

TourGuidePointer.defaultProps = {
  target: null,
  number: '',
  placement: 'left',
  offset: 3,
  zIndex: 101,
  hideNumber: false,
  floaterStyles: {},
};
